import { useContext } from 'react';
import { createContext } from 'react';

import { ModalContentProps } from '../@types/ModalContentProps';

export const ModalContentContext = createContext<ModalContentProps>({} as ModalContentProps);

ModalContentContext.displayName = 'ModalContent';

const ModalContentProvider = (props: ModalContentProps) => (
	<ModalContentContext.Provider value={props}>{props.children}</ModalContentContext.Provider>
);

export const useModalContent = () => {
	const context = useContext(ModalContentContext);

	return context;
};

export default ModalContentProvider;
